import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useResults} from "../api/resultapi";
import {Button, Col, Row} from "react-bootstrap";
import {useEffect, useRef, useState} from "react";
import Collapse from "react-bootstrap/Collapse";
import React from 'react';
import {Section} from "../components/grouping/Section";
import {minioBaseUrl} from "../data/defaultConfig";
import {PdfViewerCustom} from "../components/PdfViewerCustom";
import {pdfjs} from "react-pdf";
import {FaChevronCircleDown, FaChevronCircleUp, FaCloudDownloadAlt} from "react-icons/fa";

export function ResultsPage() {
    const {results} = useResults();
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.mjs',
        import.meta.url,
    ).toString();

    return <BasePageLayout title={'Resultaten'}>
        <div>
            {results?.map((r, index) => <HeaderItem defaultOpen={index === 0}  key={r?.id}
                                                    header={r}/>)}
        </div>

    </BasePageLayout>
}

function HeaderItem(props) {
    const {header, defaultOpen} = props;
    const [open, setOpen] = useState(!!defaultOpen);
    return <Section>
        <Button
            onClick={e => setOpen(!open)}
            className={"btn-light mb-2 shadow border-black mt-2"}
        > <Section>
            <Col className={"fs-5 ms-5 text-center"}>
                {header?.title}
            </Col>
            <Col xs={"auto"} className={"text-end"}>
                {open ? <FaChevronCircleUp/> : <FaChevronCircleDown/>}
            </Col>
        </Section>
        </Button>
        <Collapse in={open}>
            <div>
                {header?.resultFile.sort((rf1, rf2) => new Date(rf2.date) - new Date(rf1.date)).map(rf => <ResultItem
                    key={rf?.id}  result={rf}/>)}
            </div>
        </Collapse>
    </Section>
}


function ResultItem(props) {
    const {result} = props;
    const [open, setOpen] = useState(false);
    const url = result?.file?.url;

    return <Section>
        <Row className={"g-0 justify-content-center"}>
            <Col xs={6} md={4} className={'text-end'}>
                <Button
                    onClick={() => setOpen(!open)}
                    className={"btn-light border-black mb-2 w-100"}
                    aria-expanded={open}
                ><Section>
                    <Col xs={12}>
                        {result?.title}
                    </Col>
                </Section>
                </Button>
            </Col>
            <Col xs={"auto"}>
                <Button
                    href={minioBaseUrl + url}
                    target={"_blank"}
                    className={"btn-light ms-1 border-black mb-2 w-100"}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                >
                    <Section>
                        <Col>
                            <FaCloudDownloadAlt/>
                        </Col>
                    </Section>
                </Button>
            </Col>
        </Row>
        <Collapse in={open}>
            <Row className={'g-0'}>
                <Col>
                    <PdfViewerCustom url={url} />
                </Col>
            </Row>
        </Collapse>
    </Section>
}